// Make sure Swiper and jQuery are loaded before this code

// Swiper instance holders for safe re-initialization
// let mySwiperInstance = null;
// let videoSwiperInstances = [];
// let testimonialSwiperInstances = [];
// let donorSwiperInstance = null;
// let donorSwiper2Instance = null;

// Destroy all Swipers before re-initializing (prevents duplicate nav/pagination)
function destroySwipers() {
  if (mySwiperInstance && mySwiperInstance.destroy)
    mySwiperInstance.destroy(true, true);
  videoSwiperInstances.forEach(
    (swiper) => swiper && swiper.destroy && swiper.destroy(true, true)
  );
  testimonialSwiperInstances.forEach(
    (swiper) => swiper && swiper.destroy && swiper.destroy(true, true)
  );
  if (donorSwiperInstance && donorSwiperInstance.destroy)
    donorSwiperInstance.destroy(true, true);
  if (donorSwiper2Instance && donorSwiper2Instance.destroy)
    donorSwiper2Instance.destroy(true, true);

  mySwiperInstance = null;
  videoSwiperInstances = [];
  testimonialSwiperInstances = [];
  donorSwiperInstance = null;
  donorSwiper2Instance = null;
}

// Swiper initialization function
function initSwipers($) {
  // Destroy existing Swipers to prevent conflicts
  // destroySwipers();

  // alert("initSwipers called");

  // Main Swiper
  const swiperRightBtn = document.querySelector(
    ".my-swiper .swiper-button-next"
  );
  const swiperLeftBtn = document.querySelector(
    ".my-swiper .swiper-button-prev"
  );
  if (document.querySelector(".my-swiper")) {
    mySwiperInstance = new Swiper(".my-swiper", {
      speed: 400,
      spaceBetween: 20,
      centeredSlides: false,
      slidesPerView: 1.8,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      KeyboardEvents: { enabled: true },
      on: {
        reachEnd: function () {
          $(".my-swiper").css("padding-left", "0px");
        },
        fromEdge: function () {
          if (this.activeIndex === 0) {
            var logoLeft = $(".tlc-newsletter-box").offset()?.left || 0;
            $(".my-swiper").css("padding-left", logoLeft + 0 + "px");
          }
        },
        init: function () {
          var logoLeft = $(".tlc-newsletter-box").offset()?.left || 0;
          if (this.activeIndex === 0) {
            $(".my-swiper").css("padding-left", logoLeft + 0 + "px");
          } else {
            $(".my-swiper").css("padding-left", "0px");
          }
        },
        slideChange: function () {
          var logoLeft = $(".tlc-newsletter-box").offset()?.left || 0;
          if (this.activeIndex === 0) {
            $(".my-swiper").css("padding-left", logoLeft + 0 + "px");
          } else {
            $(".my-swiper").css("padding-left", "0px");
          }
        },
      },
      navigation: {
        nextEl: swiperRightBtn,
        prevEl: swiperLeftBtn,
      },
      pagination: {
        el: document.querySelector(".swiper-pagination"),
        clickable: true,
        type: "bullets",
      },
      breakpoints: {
        1920: { slidesPerView: 1.9 },
        1280: { slidesPerView: 1.8 },
        1024: { slidesPerView: 1.5 },
        575: { slidesPerView: 1.2 },
        320: { slidesPerView: 1.1, spaceBetween: 10 },
      },
    });
  }

  // Video Swipers
  videoSwiperInstances = [];

  document
    .querySelectorAll("#videos-container-slider")
    .forEach(function (slider) {
      videoSwiperInstances?.push(
        new Swiper(slider, {
          speed: 400,
          spaceBetween: 20,
          centeredSlides: false,
          slidesPerView: 3,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          KeyboardEvents: { enabled: true },

          on: {
            init: function () {
              let logoLeft = $(".tlc-newsletter-box").offset()?.left || 0;
              let rightSpace = $(window).width() - logoLeft;

              slider.querySelector(".swiper-button-prev").style.left =
                logoLeft - 60 + "px";
              slider.querySelector(".swiper-button-next").style.left =
                rightSpace + 10 + "px";
            },
          },

          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev"),
          },
          breakpoints: {
            1921: { slidesPerView: 4 },
            1280: { slidesPerView: 3 },
            1024: { slidesPerView: 2.4 },
            575: { slidesPerView: 2.1 },
            320: { slidesPerView: 1.2, spaceBetween: 10 },
          },
        })
      );
    });

  // Testimonial Swipers
  testimonialSwiperInstances = [];
  document
    .querySelectorAll(
      ".testmonial-swiper, .testmonial-swiper-four, .testmonial-swiper-two"
    )
    .forEach(function (slider) {
      testimonialSwiperInstances.push(
        new Swiper(slider, {
          speed: 400,
          spaceBetween: 5,
          centeredSlides: false,
          slidesPerView: 1,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          KeyboardEvents: { enabled: true },
          navigation: {
            nextEl: slider?.querySelector(".swiper-button-next"),
            prevEl: slider?.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: document?.querySelector(".swiper-pagination"),
            clickable: true,
          },
        })
      );
    });

  // Donor Swipers
  donorSwiperInstance = new Swiper(".donor-mySwiper", {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: document.querySelector(".donor-mySwiper .swiper-button-next"),
      prevEl: document.querySelector(".donor-mySwiper .swiper-button-prev"),
    },
  });
  new Swiper(".donor-mySwiper2", {
    // spaceBetween: 10,
    // loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    thumb: {
      swiper: donorSwiperInstance,
    }
  });
}

// Margin/padding update for Swipers (safe for missing elements)
function updateSwiperMargin($) {
  // const contentTitle = document.querySelector(".content-wrapper .title");
  var logoLeft = $(".tlc-newsletter-box").offset()?.left || 0;
  var rightSpace =
    $(window).width() - ($(".tlc-newsletter-box").offset()?.left || 0);

  var swiperLeftBtn = document.querySelector(".swiper-button-prev");
  var swiperRightBtn = document.querySelector(".swiper-button-next");

  // apply your offsets
  if (swiperLeftBtn) swiperLeftBtn.style.left = logoLeft + "px";
  if (swiperRightBtn) swiperRightBtn.style.left = rightSpace - 60 + "px";

  document
    .querySelectorAll("#videos-container-slider")
    .forEach(function (slider) {
      slider.style.paddingLeft = logoLeft + 0 + "px";
      slider.style.paddingRight = logoLeft + 0 + "px";
    });
}

jQuery(document).ready(function ($) {
  // Tooltip for venue-info

  $(".venue-details-wrapper ul")
    .on("mouseenter", "li .venue-info", function () {
      var $venueInfo = $(this);
      var $tooltip = $venueInfo.find(".tooltip");
      if ($tooltip.length) {
        var offset = $venueInfo.offset();
        var scrollTop = $(window).scrollTop();
        // var scrollLeft = $(window).scrollLeft();
        var width = $venueInfo.outerWidth();
        // Calculate the right position of .venue-info
        var right = offset.left + width - $tooltip.outerWidth();
        $tooltip.css({
          position: "fixed",
          top: offset.top - scrollTop + 25 + "px",
          left: right + "px",
          // left: (offset.left - (window.innerWidth > 767 ? 90 : -30)) + 'px',
          zIndex: 9999,
          display: "flex",
        });
      }
    })
    .on("mouseleave", "li .venue-info", function () {
      var $tooltip = $(this).find(".tooltip");
      $tooltip.css("display", "none");
    });

  // open popup for video
  $("#video-popup-btn").on("click", function () {
    $("#video-popup").fadeIn();
    $(".img-video-wrapper").fadeIn();
  });

  // close popup for video
  $("#video-popup .close-btn").on("click", function () {
    $("#video-popup").fadeOut();
    // Stop YouTube video playback on close
    var $iframe = $("#video-popup iframe");
    if ($iframe.length) {
      var src = $iframe.attr("src");
      $iframe.attr("src", src); // Reset src to stop video
    }
  });

  function resetIframes(container) {
    var $scope = container ? $(container) : $(document);
    $scope.find("iframe").each(function () {
      var $iframe = $(this);
      var src = $iframe.attr("src");
      if (src) $iframe.attr("src", src);
    });

    // // Check if iframe is in viewport
    // var rect = $iframe.getBoundingClientRect();
    // var inViewport =
    //   rect.top < (window.innerHeight || document.documentElement.clientHeight);

    // // If NOT in viewport, reset src
    // if (!inViewport) {
    //   var src = $(this).attr('src');
    //   if (src) $(this).attr('src', src);
    // }
  }

  // Listen for browser tab visibility change
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      // Optionally, you can also reset on 'visible'
      resetIframes();
    }
  });

  // Cookies widget

  $("#cookies-popup").fadeOut();

  $(
    "#cookies-widget .close-btn, #cookies-widget #decline, #cookies-widget #accept_all"
  ).on("click", function () {
    $("#cookies-widget").fadeOut();
  });

  $("#cookies-widget .setting-link").on("click", function () {
    $("#cookies-popup").css({
      opacity: 1,
      visibility: "visible",
    });
    $("#cookies-popup").fadeIn();
  });

  $(
    "#cookies-popup .close-btn, #cookies-popup #decline, #cookies-popup #accept_all"
  ).on("click", function () {
    $("#cookies-popup").fadeOut();
  });

  // truncate text functionality
  $(".toggle-text").on("click", function () {
    const $p = $(this).siblings(".truncate-text");
    $p.toggleClass("expanded");
    $(this).text($p.hasClass("expanded") ? "Read Less" : "Read More");
  });

  // tabination
  // tabControl();

  // var resizeTimer;
  // $(window).on('resize', function (e) {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(function () {
  //     tabControl();
  //   }, 250);
  // });

  // function tabControl() {
  //   var tabs = $('.tabbed-content').find('.tabs');
  //   if (tabs.is(':visible')) {
  //     tabs.find('a').on('click', function (event) {
  //       event.preventDefault();
  //       var target = $(this).attr('href'),
  //         tabs = $(this).parents('.tabs'),
  //         buttons = tabs.find('a'),
  //         item = tabs.parents('.tabbed-content').find('.item');
  //       buttons.removeClass('active');
  //       item.removeClass('active');
  //       $(this).addClass('active');
  //       $(target).addClass('active');
  //     });
  //   } else {
  //     $('.item').on('click', function () {
  //       var container = $(this).parents('.tabbed-content'),
  //         currId = $(this).attr('id'),
  //         items = container.find('.item');
  //       container.find('.tabs a').removeClass('active');
  //       items.removeClass('active');
  //       $(this).addClass('active');
  //       container.find('.tabs a[href$="#' + currId + '"]').addClass('active');
  //     });
  //   }
  // }

  // Loader for the event pagination
  $(".tito-pagination-link").on("click", function () {
    $("#tito-pagination-loader").show();
  });
  // If using AJAX navigation or page transitions, call these after new content loads:
  updateSwiperMargin($);
  initSwipers($);

  if (!localStorage.getItem("cookiesAccepted")) {
    $("#cookies-widget").fadeIn();
  }

  acceptBtn = $("#accept_all");
  acceptBtn.on("click", function () {
    localStorage.setItem("cookiesAccepted", "true");
  });

  declineBtn = $(" #cookies-widget #decline");
  declineBtn.on("click", function () {
    localStorage.setItem("cookiesAccepted", "false");
  });

  // $('ul[data-type="member"]').click(function () {
  //   // Count all .elementor-member inside the grid
  //   const count = $(
  //     ".elementor-grid.elementor-members--skin-pumori .elementor-member"
  //   ).length;

  //   alert(count);
  // });

  $(document).on("click", 'ul[data-type="member"] a', function (e) {
    e.preventDefault();

    const $clickedLink = $(this);
    const filterValue = $clickedLink.data("filter");

    const $widget = $clickedLink.closest(".nnm-be-members");

    // Elementor typically updates classes after ~300ms animation
    setTimeout(() => {
      // Find the filter UL again (it may have updated active classes)
      const $activeLink = $widget.find('ul[data-type="member"] a.active');
      const activeFilter = $activeLink.data("filter");

      const $grid = $widget.find(
        ".elementor-grid.elementor-members--skin-pumori"
      );

      let visibleCount;

      if (activeFilter === "all") {
        // Count all visible members
        visibleCount = $grid.find(".elementor-member:visible").length;
      } else {
        // Count only those of the active group AND visible
        visibleCount = $grid.find(
          `.elementor-member[data-group="${activeFilter}"]:visible`
        ).length;
      }

      console.log(
        `Active Filter: ${activeFilter} => Visible members: ${visibleCount}`
      );

      if (visibleCount < 4) {
        $widget.addClass("few-members");
      } else {
        $widget.removeClass("few-members");
      }
    }, 400); // must match or exceed Elementor's animation duration
  });

  $("#form-field-giftaid_country").countrySelect({
    preferredCountries: ["gb", "us", "in", "ca"], // put your preferred countries first
  });

  // Handle the non-deductible tax form
  $('#tax-non-deductible').on('click', function () {
    // Get parent .tax-box position left and set to #donation_form_wrapper
    var $taxBox = $(this).closest('.tax-box');
    var taxBoxOffset = $taxBox.offset();
    var taxBoxLeft = taxBoxOffset?.left - $taxBox.outerWidth();
    var taxBoxBottom = taxBoxOffset?.top + $taxBox.outerHeight();
    console.log("taxBoxLeft", taxBoxLeft, "taxBoxBottom", taxBoxBottom, taxBoxOffset);
    $(this).fadeOut();
    $('#donation_form_wrapper').fadeIn();
  });

  $('#donation_form_wrapper .close-btn').on('click', function () {
    $('#donation_form_wrapper').fadeOut();
    $('#tax-non-deductible').fadeIn();
  });

});

// Update Swipers and margins on window load
jQuery(window).on("load", function ($) {
  updateSwiperMargin($);
  initSwipers($);
});
